import { useMemo } from 'react'

const useVersionsState = ({ versionsData, isVersionsLoading, isFetching, isVersionsSuccess }) => {
  const versions = useMemo(() => (Array.isArray(versionsData) ? versionsData : []), [versionsData])
  const hasVersions = useMemo(() => versions.length > 0 && isVersionsSuccess, [versions, isVersionsSuccess])
  const versionsLoading = useMemo(() => isVersionsLoading || isFetching, [isVersionsLoading, isFetching])

  return { versions, hasVersions, versionsLoading }
}

export default useVersionsState
